import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Stack,
  Typography, Chip, Divider, CircularProgress, Alert,
} from "@mui/material";
import AssignmentIcon from "@mui/icons-material/Assignment";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { minhasFichas } from "../../services/candidatoService";

const fmt = (d) => (d ? new Date(d).toLocaleDateString("pt-BR") : "—");
const sitChip = (id) => {
  if (id >= 4) return { label: "Concluída", color: "success" };
  if (id >= 2) return { label: "Enviada", color: "info" };
  return { label: "Em preenchimento", color: "warning" };
};

export default function MinhasInscricoesDialog({ open, onClose, tokenAtual }) {
  const navigate = useNavigate();
  const [fichas, setFichas] = useState(null);

  useEffect(() => {
    if (!open) return;
    setFichas(null);
    minhasFichas().then((r) => setFichas(r.data)).catch(() => setFichas([]));
  }, [open]);

  const abrir = (f) => {
    onClose();
    if (f.EdicaoToken && f.EdicaoToken !== tokenAtual) navigate(`/inscricao/${f.EdicaoToken}`);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <AssignmentIcon color="primary" /> Minhas inscrições
      </DialogTitle>
      <DialogContent dividers>
        {fichas === null ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}><CircularProgress /></Box>
        ) : fichas.length === 0 ? (
          <Alert severity="info">Você ainda não possui fichas de inscrição.</Alert>
        ) : (
          fichas.map((f) => {
            const st = sitChip(f.IdSituacaoInscricao);
            const atual = f.EdicaoToken && f.EdicaoToken === tokenAtual;
            return (
              <Box key={f.IdFicha} sx={{ py: 1.5 }}>
                <Stack direction="row" alignItems="center" spacing={1} flexWrap="wrap" useFlexGap>
                  <Box sx={{ flexGrow: 1, minWidth: 200 }}>
                    <Typography variant="subtitle2">
                      {f.EdicaoNome || `Edição #${f.IdEdicao}`}{atual && <Chip size="small" label="Atual" sx={{ ml: 1 }} />}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Protocolo nº {f.IdFicha} • criada em {fmt(f.DtCadastro)}
                    </Typography>
                  </Box>
                  <Chip size="small" label={st.label} color={st.color} variant="outlined" />
                  <Button size="small" variant="text" startIcon={<OpenInNewIcon />} disabled={atual || !f.EdicaoToken} onClick={() => abrir(f)}>
                    {atual ? "Aberta" : "Abrir"}
                  </Button>
                </Stack>
                <Divider sx={{ mt: 1.5 }} />
              </Box>
            );
          })
        )}
      </DialogContent>
      <DialogActions><Button onClick={onClose}>Fechar</Button></DialogActions>
    </Dialog>
  );
}
